// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/global.scss'
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import en from 'element-ui/lib/locale/lang/en'
import '@/utils/rem.js'; // 引入 rem 适配脚本（PC/平板/手机三端，修复大屏 px 被 rem 放大导致的溢出与遮挡）
// import 'lib-flexible/flexible.js' // 已弃用：大屏会把根字号放大，导致 px 被 rem 放大
import deviceDetector from '@/utils/deviceDetector'; // 引入设备检测器
// 将设备检测器添加到Vue原型
Vue.prototype.$device = deviceDetector;
Vue.use(Vant);
// 设置语言
Vue.use(ElementUI, { locale: en })
Vue.config.productionTip = false;

// 创建响应式属性
Vue.mixin({
  data () {
    return {
      globalWindowWidth: deviceDetector.getWidth()
    }
  },
  created () {
    this.$nextTick(() => {
      // 使用 Vue.nextTick 确保 DOM 更新完成
      this.unsubscribe = deviceDetector.subscribe((width) => {
        Vue.nextTick(() => {
          this.globalWindowWidth = width;
        });
      });
    });
  },
  beforeDestroy () {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  computed: {
    $isPC () {
      return this.globalWindowWidth > 768;
    },
    $isMobile () {
      return this.globalWindowWidth <= 768;
    }
  }
});

// 确保在 Vue 实例创建之前进行一次强制更新
deviceDetector.forceUpdate();
new Vue({
  router, // 添加路由实例
  render: h => h(App),
}).$mount('#app')